export default __webpack_public_path__ + "media/Number1.f6fb3fbfe62e482e953405a86f456aa0.mp4";